import React from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

import TextCopyright from "atoms/text/TextCopyright"

const useStyles = makeStyles(theme => ({
  container: {
    textAlign: "left",
    backgroundColor: "#727272",
    paddingTop: "18px",
    paddingBottom: "18px",
  },
  copyright: {
    paddingRight: "20px",
    paddingLeft: "20px",
    paddingTop: "22px",
    paddingBottom: "6px",
  },
}))

const LinkLeftAdjust = () => {
  const classes = useStyles()

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.copyright}>
        <TextCopyright />
      </Grid>
    </Grid>
  )
}

export default LinkLeftAdjust
